export const typeOfRcsSupplierInfoDialog = 'typeOfRcsSupplierInfoDialog';
